import { useId } from 'react'

export const AIWidget = () => {
  return (
    <div className="group/widget peer relative z-10 size-10 shrink-0 overflow-hidden rounded-full border border-solid border-[#4573df] transition-all ">
      <div
        className="absolute top-0 z-10 size-11 -rotate-45 scale-125 bg-shine-gradient bg-[length:200%_auto] opacity-25 group-hover/widget:animate-shine"
        aria-hidden="true"
      />
      <div className="relative flex size-full items-center justify-center rounded-full border border-solid border-[#5C99FC] bg-[linear-gradient(180deg,_#3577E3_0%,_#4B8DF9_100%)]">
        <ReverAiMark width={25} height={28} />
      </div>
    </div>
  )
}

// REVER AI's mark, white on whatever blue it sits on. The filter id is unique per instance:
// the chat launcher and a button can show it on the same page.
export const ReverAiMark = ({
  width,
  height
}: {
  width: number
  height: number
}) => {
  const filter = `rever-ai-${useId().replace(/:/g, '')}`
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 22 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter={`url(#${filter})`}>
        <path
          d="M8.53906 1.09998C8.70203 1.09998 8.83475 1.23198 8.83496 1.3949C8.83496 2.61375 9.09567 3.40474 9.59082 3.89685C10.0865 4.38934 10.878 4.64392 12.083 4.64392C12.246 4.64392 12.3778 4.77584 12.3779 4.93884C12.3779 5.10194 12.2461 5.23474 12.083 5.23474C10.88 5.23474 10.0882 5.49513 9.5918 5.99158C9.09535 6.48803 8.83496 7.27975 8.83496 8.48279C8.83496 8.64588 8.70216 8.77771 8.53906 8.77771C8.37606 8.7776 8.24414 8.64582 8.24414 8.48279C8.24414 7.2803 7.98177 6.48821 7.48438 5.99158C6.98684 5.49485 6.19415 5.23474 4.99512 5.23474C4.8322 5.23453 4.7002 5.10181 4.7002 4.93884C4.7003 4.77597 4.83227 4.64413 4.99512 4.64392C6.196 4.64392 6.98756 4.38952 7.48438 3.89685C7.98069 3.40457 8.24414 2.61348 8.24414 1.3949C8.24435 1.23205 8.37619 1.10008 8.53906 1.09998Z"
          fill="white"
          className="relative group-hover/widget:animate-twinkle"
        />
        <path
          d="M13.7363 3.80713C16.98 3.80713 18.7278 6.86711 18.3223 9.30322C17.9414 11.5903 16.269 13.2461 14.5176 13.9214L16.7793 16.1997L15.7598 20.3091L10.583 15.0962L11.5107 11.3501C14.0465 11.1752 14.667 9.57619 14.667 8.65674C14.667 7.73726 14.0994 6.97998 12.6826 6.97998H11.7734L8.41211 20.2134H4.7002L7.47656 8.99561C7.6675 9.39079 8.07087 9.6644 8.53906 9.66455C9.19128 9.66447 9.72054 9.13511 9.7207 8.48291C9.72073 7.38443 9.96238 6.87507 10.2188 6.61865C10.4751 6.36225 10.9844 6.12063 12.083 6.12061C12.7352 6.12053 13.2645 5.59117 13.2646 4.93896C13.2645 4.40389 12.908 3.95214 12.4199 3.80713H13.7363Z"
          fill="white"
        />
      </g>
      <defs>
        <filter
          id={filter}
          x="2.38591"
          y="0.328547"
          width="18.3083"
          height="23.8377"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1.54286" />
          <feGaussianBlur stdDeviation="1.15714" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.129575 0 0 0 0 0.337391 0 0 0 0 0.684945 0 0 0 0.4 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_4523_2138"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_4523_2138"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  )
}
